import request from '../utils/request'

// 列表
export function visitPlanListPageApi (params) {
  return request({
    url: 'api/visitPlan/planListPage',
    method: 'get',
    params
  })
}

// 添加计划
export function visitPlanAddApi (data) {
  return request({
    url: 'api/visitPlan/addPlan',
    method: 'post',
    data
  })
}

// Plan 详情
export function visitPlanDetailApi (params) {
  return request({
    url: 'api/visitPlan/planDetail',
    method: 'get',
    params
  })
}

// 删除计划
export function visitPlanDeleteApi (planId) {
  return request({
    url: `api/visitPlan/deletePlan/${planId}`,
    method: 'post'
  })
}

// 删除计划明细
export function visitPlanDeleteDetailApi (data) {
  return request({
    url: 'api/visitPlan/deletePlanDetail',
    method: 'post',
    data
  })
}

export const visitPlanMoveApi = (data) => {
  return request({
    url: 'api/visitPlan/move',
    method: 'post',
    data
  })
}

export const planInfoApi = (planId) => {
  return request({
    url: `api/visitPlan/planInfo/${planId}`,
    method: 'get'
  })
}
